import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2423864c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invitations-list-item" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "headers p-grid p-nogutter" }
const _hoisted_4 = { class: "p-col-3" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-2" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Budget")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-2" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Rates")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-2" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Status")
], -1))
const _hoisted_11 = { class: "invitations" }
const _hoisted_12 = { class: "p-col-3" }
const _hoisted_13 = { class: "p-col-2 p-d-flex p-align-center p-text-bold" }
const _hoisted_14 = { class: "p-col-2 p-d-flex p-align-center p-text-bold" }
const _hoisted_15 = {
  key: 0,
  class: "p-d-flex p-flex-column"
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "p-col-2 p-d-flex p-align-center" }
const _hoisted_21 = { class: "p-col-3 p-d-flex p-flex-column p-justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_campaign_short_preview = _resolveComponent("campaign-short-preview")!
  const _component_user_short_preview = _resolveComponent("user-short-preview")!
  const _component_brand_short_preview = _resolveComponent("brand-short-preview")!
  const _component_status_chip = _resolveComponent("status-chip")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.viewPerspective === 'creator' || _ctx.viewPerspective === 'agencyOwner')
            ? (_openBlock(), _createElementBlock("h6", _hoisted_5, "Campaign"))
            : _createCommentVNode("", true),
          (_ctx.viewPerspective === 'brand')
            ? (_openBlock(), _createElementBlock("h6", _hoisted_6, "Creator"))
            : _createCommentVNode("", true),
          (_ctx.viewPerspective === 'admin')
            ? (_openBlock(), _createElementBlock("h6", _hoisted_7, "Campaign / Creator / Brand"))
            : _createCommentVNode("", true)
        ]),
        _hoisted_8,
        _hoisted_9,
        _hoisted_10
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaign?.invitations, (invitation) => {
          return (_openBlock(), _createElementBlock("div", {
            key: invitation.id,
            class: "invitation-item p-grid p-nogutter"
          }, [
            _createElementVNode("div", _hoisted_12, [
              (_ctx.viewPerspective === 'creator'
             || _ctx.viewPerspective === 'agencyOwner' || _ctx.viewPerspective === 'admin')
                ? (_openBlock(), _createBlock(_component_campaign_short_preview, {
                    key: 0,
                    campaign: _ctx.campaign
                  }, null, 8, ["campaign"]))
                : _createCommentVNode("", true),
              (_ctx.viewPerspective === 'brand' || _ctx.viewPerspective === 'admin')
                ? (_openBlock(), _createBlock(_component_user_short_preview, {
                    key: 1,
                    user: invitation?.creator
                  }, null, 8, ["user"]))
                : _createCommentVNode("", true),
              (_ctx.viewPerspective === 'admin')
                ? (_openBlock(), _createBlock(_component_brand_short_preview, {
                    key: 2,
                    brand: _ctx.campaign?.brand
                  }, null, 8, ["brand"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.campaign?.budget?.amount) + " " + _toDisplayString(_ctx.campaign?.budget?.currency), 1),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.campaign?.paymentMethod === _ctx.CampaignPaymentMethod.CPI)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, " Android: " + _toDisplayString(_ctx.campaign?.cpi?.android?.amount) + " " + _toDisplayString(_ctx.campaign?.budget?.currency), 1),
                    _createElementVNode("span", _hoisted_17, " IOS: " + _toDisplayString(_ctx.campaign?.cpi?.ios?.amount) + " " + _toDisplayString(_ctx.campaign?.budget?.currency), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.campaign?.paymentMethod === _ctx.CampaignPaymentMethod.CPC)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Click: " + _toDisplayString(_ctx.campaign?.cpc?.amount) + " " + _toDisplayString(_ctx.campaign?.budget?.currency), 1))
                : _createCommentVNode("", true),
              (_ctx.campaign?.paymentMethod === _ctx.CampaignPaymentMethod.CPM)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, " View: " + _toDisplayString(_ctx.campaign?.cpm?.amount) + " " + _toDisplayString(_ctx.campaign?.budget?.currency) + " Payout Cap: " + _toDisplayString(_ctx.campaign?.cpm?.payoutCap) + " " + _toDisplayString(_ctx.campaign?.budget?.currency), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_status_chip, {
                status: invitation.status
              }, null, 8, ["status"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              (_ctx.viewPerspective === 'brand' && invitation.status === 'pending')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    label: "Drop Invitation",
                    class: "p-button-link",
                    icon: "pi pi-times",
                    onClick: ($event: any) => (_ctx.confirmDeleteInvitation(_ctx.campaign, invitation))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.viewPerspective === 'creator' || _ctx.viewPerspective === 'agencyOwner' && invitation.status === 'pending')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    label: "Drop Invitation",
                    class: "p-button-link",
                    icon: "pi pi-times",
                    onClick: ($event: any) => (_ctx.confirmDeleteInvitation(_ctx.campaign, invitation))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.viewPerspective === 'creator' || _ctx.viewPerspective === 'agencyOwner' && invitation.status === 'pending')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 2,
                    label: "Accept Invitation",
                    class: "p-button-link",
                    icon: "pi pi-check",
                    onClick: ($event: any) => (_ctx.confirmInvitation(_ctx.campaign, invitation))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}